import { render } from "./ModalSetStructure.vue?vue&type=template&id=08cbf74c&scoped=true&ts=true"
import script from "./ModalSetStructure.vue?vue&type=script&lang=ts"
export * from "./ModalSetStructure.vue?vue&type=script&lang=ts"

import "./ModalSetStructure.vue?vue&type=style&index=0&id=08cbf74c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cbf74c"]])

export default __exports__